import {ToastType} from '../../shared/constants';

/* eslint-disable @typescript-eslint/no-empty-object-type */
interface DropdownOption {
  label: string;
  value: string;
}
export interface IngestionStateResponse {
  lang: string;
  defaultView: string;
  currentProjectId: number;
  defaultTileCount: number;
  sortFields: DropdownOption[];
  selectedField: string;
  ingestionStateList: DropdownOption[];
  ingestionHomeModel: {
    ingestionProgress: IngestionProgress;
    totalcount: number | null;
    totalRows: number;
    totalNumberDocuments: number;
  };
  loading: boolean;
  error: string | null;
  showApoUpdates: boolean;
}
export interface IngestionListResponse {
  lang: string;
  currentProjectId: number;
  filterState: string;
  sortBy: string;
  userID: number;
  ingestionStateList: DropdownOption[];
  sortFields: DropdownOption[];

  ingestionHomeModel: IngestionHomeModel;
}

export interface ingestionDetailsModel {
  ingestionId: number;
  projectId: number;
  ingestionName: string;
  projectName: string;
  projectIndexName: string;
  ingestionType: string;
  status: string;
  sourceLocation: string;
  ingestionGuid: string;
  startDate: string;
  endDate: string;
  cataloging: {
    status: string;
    startDate: string;
    endDate: string;
    sourceCount: number;
    fileType: string;
    catalogedCount: number;
    errorCount: number;
    catalogingHistory: {
      startDate: string;
      endDate: string;
      copiedCount: number;
      errorCount: number;
    }[];
    shouldDisplay: boolean;
  };
  copying: {
    status: string;
    startDate: string;
    endDate: string;
    copiedCount: number;
    totalCopied: number;
    totalErrors: number;
    shouldDisplay: boolean;
    copyingHistory: {
      startDate: string;
      endDate: string;
      copiedCount: number;
      errorCount: number;
    }[];
    ingestioncounts: {
      fileType: string;
      localizedFileType: string;
      sourceCount: number;
      copiedCount: number;
      errorCount: number;
      missedDocCount: number;
    }[];
  };

  indexing: any;
  canRollback: boolean;
  canEdit: boolean;
  canCopy: boolean;
  canDelete: boolean;
  canCatalog: boolean;
  canIndex: boolean;
  canRelease: boolean;
  canCopying: boolean;
  canApprove: boolean;
  canCopyReRun: boolean;
  canIndexReRun: boolean;
  canCatalogReRun: boolean;
  audioIndexGuid: string;
  ingestionStateCode: string;
  shouldEnableIndex: boolean;
}

export interface IngestionDetailsType {
  isAddOnly: boolean;
  ingestionActionCode: string;
  audioLanguage: string;
  selectedAudioLanguageList: string[];
  state: string;
  canCatalog: boolean;
  canCopy: boolean;
  canIndex: boolean;
  canCopying: boolean;
  canCatalogReRun: boolean;
  canIndexReRun: boolean;
  canCopyingReRun: boolean;
  ingestionType: string;
  isMedia: boolean;
  audioIndexGuid: string;
  ingestionDetailsModel: ingestionDetailsModel;
}

//injectionErrorResponse start
export interface IngestionErrorsModelPayload {
  ingestionId: number;
  ingestionState: string;
  sortby: string;
  errorType: string;
  docType: string;
  unPublishId: number;
  pageNumber: number;
  pageSize?: number;
  sortingOrder: string;
  sortingColumn: string;
}

export interface IngestionErrorsModelResponse {
  totalRecords: number;
  data: {
    fileName: string;
    rowNo: number;
    error: string;
    rowNumber: number;
    documentType: string;
    subject: string;
    parentID: string;
    action: string;
    isWarning: boolean;
    canIgnore: boolean;
  }[];
}

export interface IngestionErrorsUpdateModelpayLoad {
  errorArray: {
    clientUniqueCode: string;
    action: string;
  }[];
  ingestionId: number;
  projectId: number;
  errorType: string;
}

export interface IngestionErrorsUpdateModelResponse {
  message: string;
}

export interface IngestionErrorsExportPayload {
  projectId: number;
  ingestionId: number;
  docType: string;
  errorType: string;
}

export interface IngestionErrorsIgnoreAllPayload {
  projectId: number;
  ingestionId: number;
  ingestionName: string;
  ingestionStatus: string;
  errorType: string;
  docType: string;
}

export interface IngestionErrorsIgnoreAllRequestPayload {
  projectId: number;
  ingestionId: number;
  errorType: string;
  isIgnore: boolean;
}

export interface IngestionErrorsIgnoreAllResponse {
  message: string;
}

export interface IngestionErrorsIgnoreAllResponse {
  lang: string;
  disableIgnoreAll: number;
  ingestionId: number;
  projectId: number;
  ingestionStatus: string;
  ingestionName: string;
  errorType: string;
  docType: string;
}
//injectionErrorResponse end

export type IngestionDetailPropsType = {
  projectId: number;
  ingestionId: number;
};

export interface IngestionHomeModel {
  ingestionProgress: IngestionProgress[];
  totalcount: TotalCount;
  totalRows: number;
  totalNumberDocuments: number;
}

export interface IngestionProgress {
  ingestionId: number;
  name: string;
  displayName: string;
  projectId: number;
  projectName: string;
  startTime: string; // ISO date string
  status: string;
  docSourceCount: number;
  docIngestedCount: number;
  docErrorCount: number;
  lastModifiedBy: string;
  lastModifiedByDisplay: string;
  lastModifiedOn: string; // ISO date string
  completedOn: string; // ISO date string
  percentageCompleted: number;
  canStop: boolean;
  canResume: boolean;
  canRollback: boolean;
  canIndex: boolean;
  canEdit: boolean;
  canCopy: boolean;
  canDelete: boolean;
  ingestionActionCode: string;
  ingestionStateCode: string;
}

export interface TotalCount {
  totalCount: number;
}
export interface IngestionListRequest {
  filterBy: string;
  sortBy: string;
  SortingOrder: string;
  pageSize: number | undefined;
  pageNumber: number;
  ingestionNameSearchTerm: string;
}

export interface IngestionDetailsRequest {
  ingestionId: number;
  projectId: number;
}
export interface IngestionKeyValueItem {
  key: number | string | null;
  value: string;
  isSelected: boolean;
  text: string;
}

export interface IngestionCopyKeyValueItem {
  key: number | string | null;
  value: string | null;
  selected: boolean | null;
  text: string | null;
}

export interface IlstServerLocationDetails {
  value: string;
  text: string;
}

export interface IFoldersData {
  listLoadFiles: IngestionKeyValueItem[];
  message: string;
  loadDAT: string;
  loadText: string;
  loadNative: string;
  loadTIFF: string;
  loadTrans: string;
  loadPDF: string;
  loadMP3Variant: string;
  loadTranscript: string;
}

export interface IIngestionViewWizard {
  sourceSystem: IngestionKeyValueItem[];
  serverLocation: IngestionKeyValueItem[];
  columnDelimiter: IngestionKeyValueItem[];
  dataDelimiter: IngestionKeyValueItem[];
  textQualifier: IngestionKeyValueItem[];
  timeZone: IngestionKeyValueItem[];
  dateFormat: IngestionKeyValueItem[];
  lstServerLocationDetails: IlstServerLocationDetails[];
  selectedColumnDelimiterValue?: number;
  selectedDataDelimiterValue?: number;
  selectedTextDelimiterValue?: number;
  overwriteOption?: IngestionKeyValueItem[];
  annotationLayer?: IngestionKeyValueItem[];
}

export interface AnalyticsRowData {
  runType: string;
  analyticsType: string;
  startTime: string;
  endTime: string;
  status: string;
  errorMessage: string;
}

export interface AnalyticsResponse {
  data: AnalyticsRowData[];
  totalRecords: number;
}
export interface AnalyticsInfoResponse {
  canRun: boolean;
  ingestionCount: number;
  isCalEnabled: boolean;
  canFullAnalytics: number;
  canAnalyticsWithExistingClusters: number;
  canCalFullReIndex: number;
}

export interface AnalyticsRowData {
  runType: string;
  analyticsType: string;
  startTime: string;
  endTime: string;
  status: string;
  errorMessage: string;
}

export interface AnalyticsResponse {
  data: AnalyticsRowData[];
  totalRecords: number;
}
export interface AnalyticsInfoResponse {
  canRun: boolean;
  ingestionsCount: number;
  isCalEnabled: boolean;
  canFullAnalytics: number;
  canAnalyticsWithExistingClusters: number;
  canCalFullReIndex: number;
}

export interface ESIndexingInfoResponse {
  canRun: boolean;
  canRunIndexWE: number;
  canFullReIndex: number;
  esIngestionCount: number;
  excelTabProcessingEnabled: boolean;
}

export interface IIngestionHeaderResponse {
  list: IngestionKeyValueItem[];
  sourceList: string;
  datColumnHeaders: IngestionKeyValueItem[];
}

export interface IIngestionMappingPayload {
  columnHeaders: Array<{
    disabled: boolean;
    //group for now is always empty object

    group: {};
    selected: boolean;
    text: string;
    value: string;
  }>;
  actionCode: string;
  selectedKeyColumn: string;
}

export interface IMappingSourceField {
  value: string;
  text: string;
}

export interface IMappingDestinationField {
  value: number;
  text: string;
}

export interface IMappingType {
  value: string;
  text: string;
  destinationField: IMappingDestinationField[];
}

export interface IMappingRowData {
  selectedSourceFieldID: number;
  selectedTypeID: string;
  selectedDestinationID: number;
  mandatory: boolean;
  isNewRow: boolean;
  clientUniqueIdentifierRow: number;
}

export interface IMappingResponse {
  sourceField: IMappingSourceField[];
  type: IMappingType[];
  rowData: IMappingRowData[];
  rowCount: number;
  sourceList: any;
}

export interface IIngestionMappingModel {
  sequenceNo: string;
  sourceFieldID: string;
  selectedSourceField: string;
  selectedTypeID: number;
  selectedType: string;
  selectedDestinationID: number;
  destination: string;
  isMandatory: boolean;
  isNewRow: boolean;
  clientUniqueIdentifierRow: number;
  sourceField: {
    value: string;
    text: string;
  };
  type: {
    value: string;
    text: string;
    destinationField: Array<{
      value: number;
      text: string;
    }>;
  };
}

export interface IIngestionPreviewPayload {
  serverLocation: string;
  folderName: string;
  selectedFile: string;
  ingestionMappingModels: IIngestionMappingModel[];
  fieldSeparator: number;
  textSeparator: number;
  newLineSeparator: number;
  rowCount: number;
  serverLocationDetails: Array<{
    text: string;
    value: string;
  }>;
}

type FieldItem = {
  selectedSourceField: string | null;
};

export interface IIngestionPreviewResponse {
  lstFileData: FieldItem[][][];
}

export interface IIngestionSaveDraftPayload {
  ingestionSpecifySetting: {
    folderLocation: string;
    ingestionId: string;
    copyOfIngestionID: string;
    rootFolderId: string;
    sourceSystemValue: string;
    serverLocationValue: string;
    folderName: string;
    overwriteValue: string;
    columnDelimiterValue: string;
    textQulifierValue: string;
    newLineDelimiterValue: string;
    dateFormatValue: string;
    timeZoneValue: string;
    isDATFolder: boolean;
    loadFilesDATValue: string;
    keyFilesDATID: string;
    keyFilesDATValue: string;
    isNativeFolder: boolean;
    loadFilesNativeValue: string;
    isDATNative: boolean;
    filesPathNativeValue: string;
    isTextFolder: boolean;
    loadFilesTextValue: string;
    isDATText: boolean;
    filesPathTextValue: string;
    isPDFFolder: boolean;
    loadFilesPDFValue: string;
    isDATPDF: boolean;
    filesPathPDFValue: string;
    isTIFFFolder: boolean;
    loadFilesTIFFValue: string;
    isDATTIFF: boolean;
    filesPathTIFFValue: string;
    isMP3VariantFolder: boolean;
    loadFilesMP3VariantValue: string;
    isDATMP3Variant: boolean;
    filesPathMP3VariantValue: string;
    isTranscriptFolder: boolean;
    loadFilesTranscriptValue: string;
    isDATTranscript: boolean;
    filesPathTranscriptValue: string;
    isOtherFolder: boolean;
    linkTypeValue: string;
    loadFilesOtherValue: string;
    isDATOther: boolean;
    filesPathOtherValue: string;
    isRNFVFolder: boolean;
    loadFilesRNFVValue: string;
    loadFilesRNFVTXTValue: string;
    AnnotationLayerID: number;
    isDATRNFV: boolean;
    filesPathRNFVValue: string;
    filesPathRNFVTXTValue: string;
    isDATRNFVTXT: boolean;
    isRNFVTXTFolder: boolean;
    sourceColumnHeaders: Array<{
      disabled: boolean;
      group: {
        disabled: boolean;
        name: string;
      };
      selected: boolean;
      text: string;
      value: string;
    }>;
    fileHash: string;
    isDocID: boolean;
    docIDPrefix: string;
    docIDSuffix: string;
    docIDMinNum: string;
    isGenerateSearchablePDFforTIFFs: boolean;
  };
  ingestionMapping: any[];
  ingestionMappingFields: Record<string, any>;
  lstServerLocationDetails: Array<{
    text: string;
    value: string;
  }>;
}

export interface IIngestionSaveDraftResponse {
  message: string;
  ingestionId: number;
}

export interface IRunIngestionResponse {
  success: boolean;
  message?: string;
}

export interface RollbackIngestionRequest {
  ingestionId: number;
  projectId: number;
}

export interface ESIndexListItemType {
  esIndexRunID: number;
  runType: string;
  startTime: string;
  endTime: string;
  status: string;
  errorMessage: string;
  indexName: string;
}

export interface ESIndexingListResponse {
  data: ESIndexListItemType[];
  totalRecords: number;
}

export interface ExcelProcessingListItemType {
  nativeExcelIngestionID: number;
  ingestionId?: number;
  ingestionName: string;
  excelCount: number;
  startTime: string;
  endTime: string;
  status: string;
  errorMessage: string;
}

export interface ExcelProcessingListResponse {
  data: ExcelProcessingListItemType[];
  totalRecords: number;
}

export interface PaginationReqPayloadType {
  pageNumber: number;
  sortingColumn: string;
  direction: string;
  pageSize: number;
}
export interface IndexErrorsGridReqPayloadType extends PaginationReqPayloadType {
  ingestionId: number;
}

export interface IndexErrorsGridItemType {
  fileName: string;
  error: string;
}

export interface IndexErrorsGridResponse {
  totalRecords: number;
  data: IndexErrorsGridItemType[];
}

export interface ExcelProcessingErrorsGridReqPayloadType extends PaginationReqPayloadType {
  nativeExcelIngestionID: number;
}

export interface ExcelProcessingErrorGridItemType {
  sourceDocID: string;
  docID: string;
  error: string;
}

export interface ExcelProcessingErrorsGridResponse {
  totalRecords: number;
  data: ExcelProcessingErrorGridItemType[];
}

export type ESIndexingRunOptionType =
  | 'INDEXING_RUNINDEXING'
  | 'INDEXING_REINDEX';
export interface RunESIndexingPayloadType {
  selectedValue: ESIndexingRunOptionType;
}

export type AnalyticsRunOptionType = 'ANALYTICS_WII' | 'ANALYTICS_WEC_WII';
export interface RunAnalyticsPayloadType {
  selectedValue: AnalyticsRunOptionType;
}

export type ToastMessageConfigType = {
  title?: string;
  message?: string;
  type?: ToastType;
};

export type DocumentSearchTreeListType = {
  id: string;
  text: string;
  parent: string;
  // isGroup: boolean;
  searchGroupTypeCode: string | null;
  saveSearchSecurityGroupId: number;
  documentCount: number;
};

export type IngestionUnpublishViewResponse = {
  searchTreeDetails: DocumentSearchTreeListType[];
};

export interface IngestionUnpublishHistoryReqPayload {
  actionCode: string;
  pageSize: number;
  pageNumber: number;
  isAscending: string;
  sortingColumn: string;
}

export type IngestionUnpublishHistoryResponse = {
  totalRecords: number;
  data: (string | number)[][];
};
export interface UnpublishHistoryMappedRecordType {
  id: string;
  SearchId: string;
  SearchName: string;
  DocumentsCount: string;
  Status: string;
  UserUnPublished: string;
  DateUnpublished: string;
}

export const UnpublishHistoryMapkeys = [
  'id',
  'SearchName',
  'DocumentsCount',
  'Status',
  'UserUnPublished',
  'DateUnpublished',
];
export interface IngestionDatasetResponse {
  sortFields: IngestionKeyValueItem[];
  datasetTypeList: IngestionKeyValueItem[];
  publishedDocCount: number;
  iceProjectId: string;
  defaultPageSize: number;
  userRoleID: number;
  canAccessUploadSet: boolean;
  canAccessMappedSet: boolean;
  sightlineProjectId: number;
  searchString: string;
}

export interface ICEDatasetTilePageReqPayload {
  iceProjectID: number;
  datasetType: string;
  datasetSearch: string;
  displayView: string;
  sortingColumn: string;
  pageSize: number;
  pageNumber: number;
  sortingOrder: string;
  encryptedICEProjectID: string;
}
export interface ICEDatasetTileItemType {
  datasetID: number;
  name: string;
  datasetDisplayName: string;
  custodianName: string;
  datasetType: string;
  lastModifiedBy: string;
  lastModifiedOn: string;
  datasetStatus: string;
  currentStatus: string;
  lastStatus: string;
  lastStatusText: string;
  lastStatusOn: string;
  canDelete: boolean;
  totalPercentComplete: number;
  uploadedDocCount: number;
  publishedDocCount: number;
  errorDocCount: number;
  isMappedSet: boolean;
  isImportSet: boolean;
  isApoUpdate: boolean;
  isAddOnly: boolean;
  totalRows: number;
  iceDatasetID: number;
  pageNumber: number;
  isPAURole: boolean;
  currentStage: number;
  encryptedDatasetID: string;
  iceDatasetPath: string;
}
export interface ICEDataSetTilePageResponse {
  datasets: Array<ICEDatasetTileItemType>;
}

export interface IIngestionCopyRequest {
  ingestionId: number;
}

export interface IIngestionCopyResponse {
  overwriteValue: string;
  uniqueDocumentId: string;
  ingestionWizardModel: {
    ingestionSpecifySetting: {
      folderLocation: string | null;
      ingestionId: string;
      copyOfIngestionID: string;
      rootFolderId: string | null;
      sourceSystemValue: string | null;
      serverLocationValue: string | null;
      folderName: string | null;
      overwriteValue: string;
      columnDelimiterValue: string | null;
      textQulifierValue: string | null;
      newLineDelimiterValue: string | null;
      dateFormatValue: string | null;
      timeZoneValue: string | null;
      isDATFolder: boolean;
      loadFilesDATValue: string | null;
      keyFilesDATID: string | null;
      keyFilesDATValue: string | null;
      isNativeFolder: boolean;
      loadFilesNativeValue: string | null;
      isDATNative: boolean;
      filesPathNativeValue: string | null;
      isTextFolder: boolean;
      loadFilesTextValue: string | null;
      isDATText: boolean;
      filesPathTextValue: string | null;
      isPDFFolder: boolean;
      loadFilesPDFValue: string | null;
      isDATPDF: boolean;
      filesPathPDFValue: string | null;
      isTIFFFolder: boolean;
      loadFilesTIFFValue: string | null;
      isDATTIFF: boolean;
      filesPathTIFFValue: string | null;
      isMP3VariantFolder: boolean;
      loadFilesMP3VariantValue: string | null;
      isDATMP3Variant: boolean;
      filesPathMP3VariantValue: string | null;
      isTranscriptFolder: boolean;
      loadFilesTranscriptValue: string | null;
      isDATTranscript: boolean;
      filesPathTranscriptValue: string | null;
      isOtherFolder: boolean;
      linkTypeValue: string | null;
      loadFilesOtherValue: string | null;
      isDATOther: boolean;
      filesPathOtherValue: string | null;
      isRedactedNativeFolder: boolean;
      loadFilesRedactedNativeValue: string | null;
      loadFilesRedactedTextValue: string | null;
      annotationLayerValue: string | null;
      isDATRedactedNative: boolean;
      filesPathRedactedNativeValue: string | null;
      filesPathRedactedTextValue: string | null;
      sourceColumnHeaders: Array<{
        value: string;
        text: string;
      }> | null;
      fileHash: string | null;
      isDocID: boolean;
      docIDPrefix: string | null;
      docIDSuffix: string | null;
      docIDMinNum: string | null;
      isGenerateSearchablePDFforTIFFs: boolean;
    };
    ingestionMapping: Array<{
      selectedSourceFieldID: number;
      selectedTypeID: string;
      selectedDestinationID: number;
      mandatory: boolean;
      isNewRow: boolean;
      clientUniqueIdentifierRow: number;
    }> | null;
    ingestionMappingFields: {
      sourceField: Array<{
        value: string;
        text: string;
      }>;
      type: Array<{
        value: string;
        text: string;
        destinationField: Array<{
          value: number;
          text: string;
        }>;
      }>;
      rowCount: number;
      rowData: Array<{
        selectedSourceFieldID: number;
        selectedTypeID: string;
        selectedDestinationID: number;
        mandatory: boolean;
        isNewRow: boolean;
        clientUniqueIdentifierRow: number;
      }>;
      sourceList: string;
    };
  };
  fillDropDownListFromSessionResult: {
    specifySettingModel: IIngestionCopyResponse['ingestionWizardModel']['ingestionSpecifySetting'];
    serverLocationDetails: Array<{
      text: string;
      value: string;
    }>;
    sessionPreviewCount: number;
    sessionCommonConfigData: {
      commonConfigDAT: {
        folderType: string;
        folderName: string;
        matchPattern: string;
        keyColumn: number;
        pathColumn: number;
        fileDelimiter: string;
        hasHeader: boolean;
        columnPrefix: string;
      };
    };
    result: {
      SourceSystem: IngestionCopyKeyValueItem[];
      ServerLocation: IngestionCopyKeyValueItem[];
      FolderName: IngestionCopyKeyValueItem[];
      ColumnDelimiter: IngestionCopyKeyValueItem[];
      DataDelimiter: IngestionCopyKeyValueItem[];
      TextQualifier: IngestionCopyKeyValueItem[];
      DateFormat: IngestionCopyKeyValueItem[];
      TimeZone: IngestionCopyKeyValueItem[];
      OverwriteOption: IngestionCopyKeyValueItem[];
      DATLoadFiles: IngestionCopyKeyValueItem[];
      DATKeyColumn: IngestionCopyKeyValueItem[];
      LinkType: IngestionCopyKeyValueItem[];
    };
  };
}

export interface IApoListRequest {
  pageNumber: number;
  pageSize: number;
  sortingOrder: number;
  sortingColumn: string;
}

export interface IApoListResponse {
  totalRecords: number;
  data: IApoResponse[];
}

export interface IApoResponse {
  id: number;
  user: string;
  started: string;
  completed: string;
  status: string;
  custodians: number;
  eFiles: number;
  emailAddress: number;
  folders: number;
  mailStores: number;
  percentageCompleted: number;
  updatedCount: number;
  statusMessage: string;
  showProgress: boolean;
}

export interface IApoProgressResponse {
  showProgress: boolean;
  statusCode: string;
  percentageCompleted: number;
  updatedCount: number;
  jobId: number;
  statusTypeCode: string;
}

export type IApoProgressApiResponse = IApoProgressResponse;
export interface IProcSyncRecordsRequest {
  pageSize: number;
  pageNumber: number;
  sortBy: string;
  sortOrder: string;
}

export interface IProcSyncRecordsResponse {
  errors: string;
  rdoType: string;
  sourceID: number;
  lastUpdatedOn: string;
  isSaved: boolean;
}

export interface IProcSyncSummaryResponse {
  consumerLastProcess: string;
  workspaceLastProcess: string;
  syncHistoryCount: number;
  syncErrorCount: number;
  hCode: string;
}

export interface IProcSyncRetryRequest {
  projectCode: string;
  hostingPlatform: string;
  objectType: string;
  objectId: number;
}

export interface IProcSyncRetryResponse {
  message: string;
}
export interface FilterData {
  Field: string;
  Operator: string;
  Value: string;
  FromValue?: string;
  ToValue?: string;
}
export interface IndexManagementRequest {
  Page: number;
  PageSize: number;
  SortBy: string;
  SortDirection: string;
  Filters: FilterData[];
}

export interface CustomIndexFieldsRequest {
  SearchText?: string;
}

export interface CustomIndexFieldItem {
  FieldId: number;
  FieldName: string;
  AnalyzerId: number;
  AnalyzerName: string;
  FieldType?: string;
  IsDefault: boolean;
  IsEditable: boolean;
}

export interface ICustomIndexNameValidateResponse {
  isExist: boolean;
  message: string;
}
export interface CustomIndexFieldsRequest {
  SearchText?: string;
}

export interface CustomIndexFieldItem {
  FieldId: number;
  FieldName: string;
  AnalyzerId: number;
  AnalyzerName: string;
  IsDefault: boolean;
  IsEditable: boolean;
}

export interface IAnalyzer {
  AnalyzerID: number;
  AnalyzerName: string;
  AnalyzerType: string;
  AvailableForCustomIndex?: boolean;
  availableForCustomIndex?: boolean;
  StopWords?: string[];
  AlphabeticalCharacters: string[];
  WhitespaceCharacters: string[];
}

export interface IAnalyzersResponse {
  analyzers: IAnalyzer[];
  description?: string;
}

export interface IAnalyzersErrorResponse {
  title: string;
  status: number;
  details: string;
  instance: string;
}

export interface ICustomIndexAnalyzerItem {
  AnalyzerID: number;
  AnalyzerName: string;
  AnalyzerKey: string;
  Description: string;
  AnalyzerType?: string;
  analyzerID?: number;
}

export type ICustomIndexAnalyzerListResponse = ICustomIndexAnalyzerItem[];

export interface ICustomIndexAnalyzerErrorResponse {
  title: string;
  status: number;
  details: string;
  instance: string;
}
export interface CustomIndexFieldsRequest {
  SearchText?: string;
}

export interface CustomIndexFieldItem {
  FieldId: number;
  FieldName: string;
  AnalyzerId: number;
  AnalyzerName: string;
  IsDefault: boolean;
  IsEditable: boolean;
}

export type CustomIndexFieldsResponse = CustomIndexFieldItem[];

export interface IndexManagementData {
  customIndexID: number;
  indexName: string;
  securityGroups: string[];
  status: string;
  docCount: number;
  indexSize: string;
  fieldCount: number;
  createDate: string;
  lastIndexDate: string;
  userCreated: string;
  userLastIndex: string;
}
export interface IndexManagementResponse {
  page?: number;
  pageSize?: number;
  totalRecords?: number;
  items: IndexManagementData[];
}

export interface CustomIndexDetailsByIdFieldItem {
  analyzerName: string;
  fieldId: number;
  analyzerId: number;
  parentFieldID: number;
}

export interface CustomIndexDetailsByIdResponse {
  customIndexID: number;
  docCount: number;
  fields: CustomIndexDetailsByIdFieldItem[];
  indexName: string;
  savedSearchId: number;
  securityGroupIds: number[];
  notificationEmails: string[];
}

export interface CustomIndexSecurityGroupDocumentCount {
  securityGroupId: number;
  securityGroupName: string;
  documentCount: number;
}

export interface CustomIndexDocumentCountResponse {
  totalCount: number;
  securityGroupCounts: CustomIndexSecurityGroupDocumentCount[];
}

export interface ISecurityGroupIdRequest {
  securityGroupIds: number[];
  searchId: number;
}

export interface ISecurityGroupIdResponse {
  securityGroupUserCounts: ISecurityGroupCountResponse[];
}

export interface ISecurityGroupCountResponse {
  securityGroupId: number;
  securityGroupName: string;
  userCount: number;
  documentCount?: number;
}
